import Fee from "@/model/Fee/Fee"

interface ApplicationFee {

}

class ApplicationFee extends Fee {
    constructor(
        reference: string,
        value: number,
    ) {
        super(reference, value)
    }
}

export default ApplicationFee